import { cssVars } from '@lmc/design-system/tokens'
import styled from 'styled-components'

const { borderWidth, color, spacing } = cssVars

/**
 * Fields revealed by a tickbox or answer, indented under it behind a grey rule,
 * as designed. `$gap` is the space between them, 24px unless set.
 */
export const StepReveal = styled.div<{ $gap?: string }>`
  border-left: ${borderWidth[100]} solid ${color.border.subtle};
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = spacing[300] }) => $gap};
  margin-left: ${spacing[100]};
  padding-left: ${spacing[200]};
`

/** A tickbox and the `StepReveal` under it: 8px between them. */
export const StepRevealGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[100]};
`
